import shp from 'shpjs';
import proj4Src from 'proj4';

export default {
  methods: {
    async shapefileToGeojson(zipFile) {
      const archive = await zipFile.arrayBuffer();
      const collection = await shp(archive);
      this.projectGeojson(collection);

      return collection;
    },
    projectGeojson(collection) {
      const { forward } = proj4Src('EPSG:4326', 'EPSG:3857');

      collection.features.forEach((feature) => {
        if (feature.geometry.type === 'Polygon') {
          feature.geometry.coordinates = feature.geometry.coordinates.map(ring => ring.map(point => forward(point))); // eslint-disable-line no-param-reassign
        } else if (feature.geometry.type === 'LineString') {
          feature.geometry.coordinates = feature.geometry.coordinates.map(point => forward(point)); // eslint-disable-line no-param-reassign
        } else if (feature.geometry.type === 'Point') {
          feature.geometry.coordinates = forward(feature.geometry.coordinates); // eslint-disable-line no-param-reassign
        }
      });
    },
    maxPointCount(collection) {
      let total = 0;
      let max = 0;
      collection.features.forEach((feature) => {
        if (feature.geometry.type === 'Polygon') {
          feature.geometry.coordinates.forEach((ring) => {
            total += ring.length;
            if (ring.length > max) {
              max = ring.length;
            }
          });
        } else if (feature.geometry.type === 'LineString') {
          total += feature.geometry.coordinates.length;
          if (feature.geometry.coordinates.length > max) {
            max = feature.geometry.coordinates.length;
          }
        } else if (feature.geometry.type === 'Point') {
          total += 1;
          max = 1;
        }
      });
      return [total, max];
    },
  },
};
